// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import dayjs from "dayjs"
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

// let vSerachText = "";

export default function GroupListTable(props) {

  const { onSelectGroupChange } = props;

  const groups = props.groups || [];
  // console.log('GroupListTable ~ groups:', groups);
  const selGroupIDs = props.selGroupIDs || [];

  const gridData = groups.map(item => {
    return {
      ...item,
      GroupNameDisplay: `[${item.Name}]`,
    }
  })

  // console.log("gridData", gridData);

  const [selGroups, setSelGroups] = useState([]);
  const [selectedGroupNames, setSelectedGroupNames] = useState("");

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);

    params.api.forEachNode(function (node) {
      node.setSelected(selGroupIDs.includes(node.data.GroupID));
    });
  };

  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();


    let selGroups = nodes.map(item => {
      return item.data
    });

    setSelGroups(selGroups);

    // const vIDs = selGroups.map(x => x.GroupID);
    // console.log("change selGroups", selGroups);
    onSelectGroupChange && onSelectGroupChange(selGroups);

    const vNames = selGroups.map(x => x.GroupNameDisplay);
    setSelectedGroupNames(vNames.join(", "));

  }


  const [searchText, setSearchText] = useState("");
  const handleSearchTextChange = (e) => {
    const vVal = e.target.value;
    // console.log("handleSearchTextChange", vVal);
    setSearchText(vVal);
    // vSerachText = vVal;

    // gridApi.onFilterChanged();
    gridApi.setQuickFilter(vVal);
  }

  const handleGetRowId = useCallback((params) => params.data.GroupID, []);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorGroupID = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.GroupID, nodeB.data.GroupID)
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }

  const columnDefs = [
    {
      field: 'GroupID', headerName: "GroupID", cellStyle: cellStyle, width: 150,
      headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorGroupID
    },
    { field: 'Name', headerName: "Name", cellStyle: cellStyle, minWidth: 100, flex: "1", comparator: comparatorName },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, width: 150, comparator: comparatorDesc },
  ];

  // <AgGridColumn field="GroupID" headerName="GroupID" cellStyle={cellStyle} width={150} headerCheckboxSelection checkboxSelection={true} />
  // <AgGridColumn field="Name" headerName="Name" cellStyle={cellStyle} flex="1" minWidth={100} />
  // <AgGridColumn field="Desc" headerName="Description" cellStyle={cellStyle} width={150} />


  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1, p: 0 }}>
        <Box sx={{ flexGrow: 1, pb: 1 }}>
          <Grid container spacing={{ xs: 1 }}  >
            <Grid item xs={4}>
              <TextField
                id="standard-group-search"
                label="Search"
                type="search"
                variant="standard"
                value={searchText}
                onChange={handleSearchTextChange}
              />
            </Grid>
            <Grid item xs={8} sx={{ maxHeight: "6em", overflow: 'auto', }}   >
              Selected({selGroups?.length || 0}): {selectedGroupNames}
            </Grid>
          </Grid>



        </Box>

        <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
          <AgGridReact

            rowData={gridData}

            defaultColDef={{
              width: 100,
              resizable: true,
              sortable: true,
              suppressMovable: true,
            }}
            columnDefs={columnDefs}
            headerHeight={40}

            suppressNoRowsOverlay

            rowSelection="multiple"
            rowMultiSelectWithClick
            onSelectionChanged={onSelectionChanged}
            onGridReady={onGridReady}

            // getRowNodeId={(data) => data.GroupID}
            getRowId={handleGetRowId}
          >

          </AgGridReact>

        </div>

      </Box>
    </React.Fragment>


  );
}

GroupListTable.propTypes = {
  groups: PropTypes.array,
  selGroupIDs: PropTypes.array,
  onSelectGroupChange: PropTypes.func,
};
